import { SLD } from '@/utils/INTERFACE';
import Queue from '@/utils/queue';
import { getSystem } from '@/utils/site';
import { getChannelNumber } from '@/utils/siteDefs';
import http from '../utils/http';
import { getTemplateLanguage } from '../utils/language';
import { getPlatform } from '@/utils/page';

export async function getCouponInfo(key) {
    var res = await http.get('/pub/page/queryCouponInfo', {
        key,
        language: getTemplateLanguage()
    })
    if(getSystem()=='ept'){
        let info = res.couponList[0]
        return {
            activityKey: key,
            ...info,
            limitStr: info.description,
            couponLink: undefined
        }
    }
    return {
        ...res.coupon,
        couponUrl: key
    }
}




const couponStatusQueue = new Queue(async function (arr) {
    var res = await http.jsonp.get(`${SLD().rest}/coupon/queryCouponState`, {
        key: arr.join(',')
    })
    return res
})

export async function getCouponState(key) {
    let sys = getSystem()
    let res= await couponStatusQueue.get(key)
    if (sys == 'th') {
        if (!res || !res.resultCode) {
            throw new Error(res.message)
        }
        res.isCollected = res.resultCode == 14 || res.resultCode == 15
        res.isDisable = res.resultCode == 17
        return res
    }
    if(sys == 'ept'){
        if (res.code == "0005") {
            res.isCollected = true
        }
        if (res.code == '0003' || res.code == '0004' || res.code == '0006' || res.code == '0008') {
            res.isDisable = true
        }
        return res
    }
}


export async function getCoupon(id, key) {
    let sys = getSystem()
    if (sys == 'ept') {
        let eid = window.eid
        if (!eid) {
            throw new Error("no eid")
        }
        let res = await http.jsonp.get(`${SLD().rest}/coupon/getCoupon`, {
            key:id,
            eid,
            channel: getChannelNumber(),
            language: getTemplateLanguage()
        })
        if(res.code=='0020'){
            let err=new Error(res.extMsg)
            err.code=5
            throw err
        }
        if(res.code!='0000'){
            throw new Error(res.extMsg)
        }
        res.resultMsg=res.extMsg
        return res
    }
    if (sys == 'th') {
        const platformDefs={
            'pc':0,
            'app':1,
            'mob':3
        }
        let {platform}=getPlatform()
        let res = await http.jsonp.get(`${SLD().rest}/coupon/getCoupon`, {
            ruleId: id,
            key,
            platform:platformDefs[platform],
            language: getTemplateLanguage()
        })
        if(!res.result) {
            throw new Error(res.resultMsg)
        }
        if(res.resultCode==5){
            let err=new Error(res.resultMsg)
            err.code=5
            throw err
        }
        return res
    }
}